/**
 * Los tres packs del MVP, validados en la carga: un pack mal formado revienta al
 * importar el módulo, no en mitad de una partida.
 */

import casaSenorialJson from './packs/casa-senorial.json';
import congresoHotelJson from './packs/congreso-hotel.json';
import rodajeSerieJson from './packs/rodaje-serie.json';
import type { ThemePack } from './schema';
import { parseThemePack } from './schema';

export const casaSenorial: ThemePack = parseThemePack(casaSenorialJson);
export const rodajeSerie: ThemePack = parseThemePack(rodajeSerieJson);
export const congresoHotel: ThemePack = parseThemePack(congresoHotelJson);

export const PACKS: readonly ThemePack[] = [casaSenorial, rodajeSerie, congresoHotel];

export function getPack(id: string): ThemePack {
  const pack = PACKS.find((p) => p.id === id);
  if (pack === undefined) throw new Error(`pack desconocido: "${id}"`);
  return pack;
}
